"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlessingOfFrostAbilityHandler = exports.BlessingOfFrostActorAbilityFactory = exports.BlessingOfFrostAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class BlessingOfFrostAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BlessingOfFrost;
        this.__typeName = "BlessingOfFrost";
    }
}
exports.BlessingOfFrostAbilityArgs = BlessingOfFrostAbilityArgs;
let BlessingOfFrostActorAbilityFactory = class BlessingOfFrostActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BlessingOfFrost", "AllAllies", 4);
    }
};
BlessingOfFrostActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BlessingOfFrost")
], BlessingOfFrostActorAbilityFactory);
exports.BlessingOfFrostActorAbilityFactory = BlessingOfFrostActorAbilityFactory;
let BlessingOfFrostAbilityHandler = class BlessingOfFrostAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(targetId => {
                    container.applyBuff({
                        sequence,
                        creatorId: ability.invokerId,
                        targetId,
                        duration: Duration_1.Duration.Turns(4),
                        effect: new core_1.ReciprocateAttackEffectArgs(Duration_1.Duration.Turns(2), new core_1.SlowEffectArgs(1), true, 15),
                        onApplied: sequence => {
                            sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "IceBubble"));
                        }
                    });
                });
            }
        });
    }
};
BlessingOfFrostAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BlessingOfFrost)
], BlessingOfFrostAbilityHandler);
exports.BlessingOfFrostAbilityHandler = BlessingOfFrostAbilityHandler;
